module.exports = __webpack_public_path__ + "static/media/succes-icon.9411398c.svg";